import { NonFinancialDriverNodeList } from '../../core/api/types/non-financial-drivers';
import { NonFinancialDriverTree, NonFinancialDriverTreeNode } from '../types';

const sortTree = (tree: NonFinancialDriverTreeNode[]) => {
  tree.sort((a, b) => a.order - b.order);
  tree.forEach(node => sortTree(node.children));
};

const updateDepths = (tree: NonFinancialDriverTreeNode[], depth = 0) => {
  tree.forEach(node => {
    node.depth = depth;
    updateDepths(node.children, depth + 1);
  });
};

const updateOrders = (tree: NonFinancialDriverTreeNode[]) => {
  tree.forEach((node, index) => {
    node.order = index;
    updateOrders(node.children);
  });
};

export const createTreeFromIndex = (index: Record<string, NonFinancialDriverTreeNode>) => {
  const tree: NonFinancialDriverTreeNode[] = [];

  Object.values(index).forEach(node => {
    node.children = [];
  });

  Object.values(index).forEach(node => {
    const parent = node.parentId ? index[node.parentId] : undefined;

    if (parent) {
      parent.children.push(node);
    } else {
      tree.push(node);
    }
  });

  sortTree(tree);
  updateDepths(tree);
  updateOrders(tree);

  return tree;
};

export const duplicateTree = (index: Record<string, NonFinancialDriverTreeNode>): NonFinancialDriverTree => {
  const newIndex = Object.values(index).reduce<Record<string, NonFinancialDriverTreeNode>>((output, node) => {
    output[node.id] = {
      ...node,
      values: { ...node.values },
      children: []
    };
    return output;
  }, {});

  return {
    tree: createTreeFromIndex(newIndex),
    index: newIndex
  };
};

export const flattenTree = (
  tree: NonFinancialDriverTreeNode[],
  nodes: NonFinancialDriverTreeNode[] = []
): NonFinancialDriverTreeNode[] => {
  tree.forEach(node => {
    nodes.push(node);
    flattenTree(node.children, nodes);
  });

  return nodes;
};

export const getChildIds = (children: NonFinancialDriverTreeNode[], ids: string[] = []): string[] => {
  children.forEach(node => {
    ids.push(node.id);
    getChildIds(node.children, ids);
  });

  return ids;
};

const convertTreeNodeToOrderNode = (node: NonFinancialDriverTreeNode): NonFinancialDriverNodeList => ({
  node_id: node.id,
  name: node.name,
  is_group: node.isGroup,
  parent_id: node.parentId || null,
  order: node.order,
  driver_type: node.type,
  decimal_display: node.decimalDisplay,
  is_excel_driver: node.is_excel_driver
});

export const convertTreeToOrder = (
  tree: NonFinancialDriverTreeNode[],
  output: NonFinancialDriverNodeList[] = []
): NonFinancialDriverNodeList[] => {
  tree.forEach(node => {
    output.push(convertTreeNodeToOrderNode(node));
    convertTreeToOrder(node.children, output);
  });

  return output;
};
